module.exports = __webpack_public_path__ + "static/media/gb4.8f0d2786.JPG";